import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    to: Number,
    duration: { type: Number, default: 1100 },
    format: { type: String, default: "number" },
    suffix: { type: String, default: "" },
    decimals: { type: Number, default: 0 },
    delay: { type: Number, default: 0 }
  }

  connect() {
    if (!this.hasToValue) return
    this.element.textContent = this.format(0)

    const rect = this.element.getBoundingClientRect()
    const alreadyVisible = rect.top < window.innerHeight && rect.bottom > 0

    if (alreadyVisible) {
      setTimeout(() => this.animate(), this.delayValue)
      return
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.observer.disconnect()
          setTimeout(() => this.animate(), this.delayValue)
        }
      })
    }, { threshold: 0, rootMargin: "0px 0px -10% 0px" })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
    if (this.raf) cancelAnimationFrame(this.raf)
  }

  animate() {
    const start = performance.now()
    const end = this.toValue
    const duration = this.durationValue

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1)
      const eased = 1 - Math.pow(1 - progress, 3)
      const value = end * eased
      this.element.textContent = this.format(value)
      if (progress < 1) {
        this.raf = requestAnimationFrame(tick)
      }
    }
    this.raf = requestAnimationFrame(tick)
  }

  format(value) {
    const decimals = this.decimalsValue
    const rounded = decimals > 0 ? value.toFixed(decimals) : Math.round(value)
    const formatter = new Intl.NumberFormat("fr-FR", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    })
    const num = formatter.format(rounded)
    return `${num}${this.suffixValue}`
  }
}
